module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9644.25991d5f.jpg";